<template>
    <div class="m-photos">
        <template v-if="photosStatus === 'idle'">
            <div
                v-for="(photo, photoIdx) in photos"
                :key="photoIdx"
                class="m-photos__itemWrapper"
            >
                <div class="m-photos__item">
                    <label
                        :for="`photo_${photoIdx}`"
                        class="m-photos__checkbox"
                    >
                        <figure class="m-photos__imageWrapper">
                            <img
                                class="m-photos__image"
                                :src="photo.image"
                                alt=""
                            />
                        </figure>
                        <input
                            type="checkbox"
                            :id="`photo_${photoIdx}`"
                            class="m-photos__checkboxInput"
                            :value="photo.id"
                            v-model="checkedPhotos"
                        >
                        <div class="m-photos__labelWrapper">
                            <div class="m-photos__labelContent">
                                <a-icon icon="RemoveSmall" />
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </template>
        <div
            v-else
            class="m-photos__itemWrapper"
        >
            <div class="m-photos__item">
                <a-icon icon="Spinner" />
            </div>
        </div>
        <div class="m-photos__itemWrapper">
            <div class="m-photos__item m-photos__item--button">
                <button
                    class="m-photos__itemButton"
                    @click.prevent="$router.push({ name: 'photos' })"
                >
                    <span>
                        <a-icon
                            icon="Photo"
                            class="m-photos__itemIcon"
                        />
                        Dodaj zdjęcia
                    </span>
                </button>
            </div>
        </div>
        <a-button
            v-if="checkedPhotos.length > 0"
            class="m-photos__remove"
            type="fullwidth"
            @click.prevent="removePhotos"
        >
            Usuń wybrane
        </a-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checkedPhotos: []
        }
    },
    props: {
        photos: {
            type: Array,
            default: () => []
        },
        routerBack: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        photosStatus() {
            return this.$store.getters.photosStatus
        }
    },
    methods: {
        removePhotos() {
            this.$store.dispatch('removePhotos', this.checkedPhotos).then(() => {
                this.checkedPhotos = []
            })
        }
    },
    created() {
        if(this.routerBack) {
            this.$store.dispatch('setPhotosRouterBack', this.routerBack)
        }
    }
}
</script>
